function addOrUpdate<T extends { id: string }>(list: T[], item: T): T[] {
  return list.find(link => link.id === item.id)
    ? list.map(link => (link.id === item.id ? { ...link, ...item } : link))
    : [...list, item];
}

export { addOrUpdate };
